"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _lodash = require("lodash");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _MediaContext = _interopRequireDefault(require("./MediaContext"));

var _Store = _interopRequireDefault(require("./Store"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var supportedHTML5VideoFormats = ["mp4", "webm", "ogg"];

var Index = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(Index, _React$Component);

  function Index() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    _defineProperty(_assertThisInitialized(_this), "setRef", function (element) {
      var _element$src;

      if (!element) return;

      _this.store.actions.pushMediaNode(element);

      var startTime = Number.parseInt((0, _lodash.get)(_assertThisInitialized(_this), "props.startTime", 0), 10);
      var advanceToFirstHit = (0, _lodash.get)(_assertThisInitialized(_this), "props.advanceToFirstHit", 0);
      var externalHits = (0, _lodash.get)(_assertThisInitialized(_this), "props.externalHits");
      if (advanceToFirstHit && (0, _lodash.isString)(advanceToFirstHit)) advanceToFirstHit = Number.parseInt(advanceToFirstHit, 10);

      if (!startTime && advanceToFirstHit && Array.isArray(externalHits)) {
        var time = _(externalHits).map("hits").flatten().map("s").flattenDeep().sortBy(_lodash.identity).value()[0];

        if (time && (0, _lodash.isNumber)(time)) {
          startTime = time / 1000;
        }
      }

      if (startTime) {
        element.addEventListener("loadedmetadata", function () {
          this.currentTime = startTime;
        }, false);
      } // Split src to isolate filetype


      var elementSrcSplit = element === null || element === void 0 ? void 0 : (_element$src = element.src) === null || _element$src === void 0 ? void 0 : _element$src.split(/[.?]/);

      if (!supportedHTML5VideoFormats.some(function (format) {
        return elementSrcSplit.includes(format);
      })) {
        element.style.display = "none";
      }
    });

    _this.store = (0, _Store["default"])();
    return _this;
  }

  var _proto = Index.prototype;

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.store.destroy();
  };

  _proto.render = function render() {
    var _this$props = this.props,
        children = _this$props.children,
        mediaUrl = _this$props.mediaUrl;
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("video", {
      ref: this.setRef,
      src: mediaUrl
    }), /*#__PURE__*/_react["default"].createElement(_MediaContext["default"].Provider, {
      value: this.store
    }, children));
  };

  return Index;
}(_react["default"].Component);

Index.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes["default"].oneOfType([_propTypes["default"].arrayOf(_propTypes["default"].node), _propTypes["default"].node]).isRequired
} : {};
var _default = Index;
exports["default"] = _default;